import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks"
import { colors } from "../../../../ui/colors"
import { ArrowLeftIcon } from "../../../../ui/icons/arrow-left"
import { Layout } from "../../../../ui/layout"
import { ButtonComponent } from "../../../../ui/molecules/button/newButton"
import { MenuItems } from "../../../../ui/organisms/navbar/dto"
import { PacDetailUpdate, PACDetailValidation, resetPACDetailValidationStatus } from "../slice"
import { EditPACForms } from "./forms"

export function EditPAC() {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const sessionState = useAppSelector(state => state.session)
    const pacState = useAppSelector(state => state.pac)

    useEffect(() => {
        if (pacState.PACDetailValidationStatus === 'successfully') {
            dispatch(resetPACDetailValidationStatus())
            dispatch(PacDetailUpdate({ body: pacState.PACDetailUpdateRequest, id: pacState.PACDetailIdToUpdate }))
        }
    }, [pacState.PACDetailValidationStatus])

    useEffect(() => {
        if (pacState.PACDetailUpdateStatus === 'successfully') {
            navigate('/pac')
        }
    }, [pacState.PACDetailUpdateStatus])

    return (
        <Layout
            menuItem={MenuItems.GESTIONE_CONTROLLO}
            breadcrumbItems={['Gestione Controllo', 'PAC', 'Modifica PAC']}
            headerLabel={`Modifica Dettaglio PAC - ${pacState.PACDetailClient}`}
            rightBar={true}
            headerIcon={
                <ArrowLeftIcon onClick={() => navigate('/pac')} color={colors.white} />
            }
            headerChildren={
                <div className="flex items-center h-[100%] w-[100%] justify-end">
                    <ButtonComponent
                        size={"sm"}
                        iconPosition={"off"}
                        variant={"solid"}
                        label="Salva"
                        color={"orange"}
                        onClick={() => {
                            dispatch(PACDetailValidation(pacState.PACDetailUpdateRequest))
                        }}
                    />
                </div>
            }
        >
            <EditPACForms />
        </Layout>
    )
}